import { createStore } from 'vuex'
import db from '../database/firestore'
import { collection, getDocs, query, where, doc, deleteDoc, setDoc, addDoc } from 'firebase/firestore'

export default createStore({
  state: {
    deviceList: [],
    currentUser: null
  },
  mutations: {
    async addDevice(state, device){
      const docRef = await addDoc(collection(db, "devices"), device)
      device.docId = docRef.id
      state.deviceList.push(device)
    },

    async removeDevice(state, device){
      state.deviceList = state.deviceList.filter(item => item!==device)
      await deleteDoc(doc(db, "devices", device.docId))
    },

    async updateDevice(state, device){
      let indexToUpdate = state.deviceList.findIndex(
        (element) => {
          return element.docId==device.docId
        }
      )
      state.deviceList[indexToUpdate] = device
      await setDoc(doc(db, "devices", device.docId), device)
    },

    setDeviceList(state, deviceList){
      state.deviceList = deviceList
    },

    toggleSelection(state, device){
      device.selected = !device.selected
    }
  },
  actions: {
    async fetchDeviceListFromDB({ commit }){
      const devices = []
      const q = query(collection(db, "devices"), where("uid", "==", this.state.currentUser.uid))
      const querySnapshot = await getDocs(q)
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const data = {
          uid: doc.data().uid,
          docId: doc.id,
          name: doc.data().name,
          category: doc.data().category,
          last_updated_date: doc.data().last_updated_date,
          selected: false
        }
        devices.push(data)
      })
      commit('setDeviceList', devices)
    },

    async submitDeviceListToDB({ commit }){
      const databaseCollection = db.collection('devices')

      this.state.deviceList.forEach(async device => {
        await databaseCollection.doc(device.docId).set(device)
      })
    },

    setDeviceDate({ commit }, {device, newdate}){
      device.last_updated_date = newdate
      commit('updateDevice', device)
    },
    
    resetDeviceDate({ commit }, device){      
      let newdate = Date.now()
      this.dispatch('setDeviceDate', {device, newdate})
    },

    setCurrentUser({ commit }, user){
      this.state.currentUser = user
    }
  },
  getters: {
    deviceList(state){
      return state.deviceList
    },
    
    currentUser(state){
      return state.currentUser
    }
  },
  modules: {
  }
})
